import { Space } from 'antd-mobile'
import { SpaceProps } from 'antd-mobile/es/components/space'
import React, { ReactNode } from 'react'

interface VerticalSpaceProps extends SpaceProps {
  size?: number
  children: ReactNode
}
function VerticalSpace({ size, children, ...restProps }: VerticalSpaceProps) {
  return (
    <Space
      direction="vertical"
      style={{ width: '100%', '--gap': `${size || 0}px` }}
      {...restProps}
    >
      {children}
    </Space>
  )
}

export default VerticalSpace
